export default __webpack_public_path__ + "static/media/SSJ.ed542e2f.jpg";